import { render, staticRenderFns } from "./SendInvitation.vue?vue&type=template&id=3ef852f3&scoped=true&"
import script from "./SendInvitation.vue?vue&type=script&lang=js&"
export * from "./SendInvitation.vue?vue&type=script&lang=js&"
import style0 from "./SendInvitation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SendInvitation.vue?vue&type=style&index=1&id=3ef852f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef852f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
